import { environment } from "src/environments/environment";
import { __User, Attachment, ChatMessage, Pagination } from "../shared/model/chat.message";
import { ChatAgent } from "../shared/model/user-interfaces";

export const msgWidth = 348;
export const msgHeight = 348;
export const MSG_MAX_LENGTH = 10000;
export const PREVIEW_SM_MAZ_SIZE = 3 * 1024;
export const PREVIEW_LG_MAX_SIZE = 2 * 1024 * 1024;
export const PER_PAGE_MESSAGES = 30;
export const BASE_64_PATTERN = 'data:image/png;base64,';
export const GIF_LOADER_SRC = 'assets/custom-images/small-loader.gif';
export const BOT_SVG_SRC = 'assets/svg/login/bot_logo.svg';


export function GET_CHAT_ENV_URL(): string {
    return localStorage?.getItem('chatUrl')?.trim() || environment.chatUrl;
}

export function GET_CHAT_SOCKET_ENV_URL(): string {
    return localStorage?.getItem('wsChatUrl')?.trim() || environment.wsChatUrl;
}

export function RESET_PAGINATOR(paginator: Pagination = null, per_page = 10, current_page = 1): Pagination {
    if (paginator?.per_page) {
        per_page = paginator.per_page;
    }
    return {
        current_page: current_page,
        previous_page: 0,
        per_page: per_page
    };
}

export function REMOVE_TEXT_AFTER_AT(value: string): string {
    if (!value) return value;
    const atIndex = value?.indexOf('_');
    return atIndex !== -1 ? value.substring(0, atIndex) : value;
}


export function GET_FULL_NAME(user: ChatAgent): string {
    let name = "";
    if (user?.first_name?.length) {
        name += user.first_name;
    }
    if (user?.last_name?.length) {
        name += " " + user.last_name;
    }
    return name;
}

/**
 * Checks whether a file is an image or one of the specified docs.
 */
export function IS_SUPPORTED_FILE(file: File): boolean {
    // Common image MIME prefixes
    const imageMimePattern = /^image\//;

    // Whitelisted document extensions
    const docExtensions = [
        'xlsx', 'xls',
        'pptx', 'ppt',
        'docx', 'doc',
        'txt', 'csv',
        'pdf'
    ];

    // 1) If the browser knows it’s an image, accept.
    if (imageMimePattern.test(file.type)) {
        return true;
    }

    // 2) Otherwise fallback to checking extension.
    const parts = file.name.split('.');
    if (parts.length < 2) {
        return false; // no extension
    }
    const ext = parts.pop()!.toLowerCase();
    return docExtensions.includes(ext);
}

export const success = (status: number) => {
    return status == 200;
};

export const _success = (res: any) => {
    return res?.data == 'SUCCESS';
};

export const RES_OK = (res: any) => {
    return [200, 201].includes(res?.statusCode ?? 0) || res?.success === true || res?.data === 'SUCCESS';
};

export const isImageOrVideo = (item: Attachment) => {
    return (item?.image_url || item?.video_url) ? true : false;
};

export const isImage = (item: Attachment) => {
    return item?.image_url ? true : false;
};

export const isVideo = (item: Attachment) => {
    return item?.video_url ? true : false;
};


//find image dimensions FROM FILE
export function GET_IMAGE_DIMENSION_FROM_FILE(file: File): Promise<{ width: number, height: number }> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event: any) => {
            const img = new Image();
            img.onload = () => {
                resolve({ width: img.width, height: img.height });
            };
            img.src = event.target.result;
        };

        reader.readAsDataURL(file);
    });
}

//find image dimensions FROM base64
export function GET_IMAGE_DIMENSION_FROM_BASE64(base64Image: string): Promise<{ width: number, height: number }> {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = base64Image;
        img.onload = () => {
            const width = img.width;
            const height = img.height;
            resolve({ width, height });
        };

        img.onerror = (err) => {
            reject(err);
        };
    });
}

export function CALCULATE_ASPECT_RATIO(width: number, height: number): Promise<{ aspectWidth: number, aspectHeight: number }> {

    return new Promise((resolve, reject) => {

        function gcd(a: number, b: number): number {
            return b === 0 ? a : gcd(b, a % b);
        }
        const gcdData = gcd(width, height);
        const aspectWidth = width / gcdData;
        const aspectHeight = height / gcdData;
        resolve({ aspectWidth, aspectHeight });
    });
}


/** 
 * @description
 * @argument array of objects
 * @property in the object based on which duplicates will be removed
 * remove duplicate data based on the params provided like id*/
export function MAKE_ARRAY_UNIQUE(arr: any[], property: string, property2?: string) {
    try {
        if (!Array.isArray(arr) || typeof property !== "string") {
            return [];
        }
        //filter signature: (object, index, thisArray)
        const uniqueArray = arr?.filter((obj, index, self) => {
            if (obj && typeof obj === "object") {
                const firstIndex = self?.findIndex(data => data && (data[property] == obj[property] && !property2 || (property2 && data[property] == obj[property] && data[property2] == obj[property2])));
                if (index !== firstIndex) {
                    console.log("At index " + index + " Duplicate object found:", obj);
                    console.log('The array is', arr);
                }
                return index === firstIndex;
            } else {
                return false;
            }
        });

        return uniqueArray;
    } catch (error) {
        console.log('MAKE_ARRAY_UNIQUE error', error);
    }
}

export const MESSAGES_LIST: any[] = [];


